"use client";

import { useApp } from "./AppProvider";
import type { CTAData } from "@/lib/cms";

interface CTABannerProps {
  data: CTAData;
}

export default function CTABanner({ data }: CTABannerProps) {
  const { isRTL } = useApp();
  const h = (en: string, ar: string) => isRTL ? (ar || en) : en;

  return (
    <section style={{ padding: "4rem 0" }}>
      <div className="container">
        <div className="cta-banner-inner">
          <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, background: "rgba(255,255,255,0.08)", borderRadius: "50%", filter: "blur(40px)" }} />
          <div style={{ position: "absolute", bottom: -60, left: -60, width: 250, height: 250, background: "rgba(7,174,185,0.2)", borderRadius: "50%", filter: "blur(40px)" }} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "0.4rem 1rem", borderRadius: "50px", background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.25)", color: "white", fontSize: "0.78rem", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1.5rem" }}>
              ✦ {h(data.badge_en, data.badge_ar)}
            </div>
            <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 3rem)", fontWeight: 900, marginBottom: "1rem", letterSpacing: "-0.02em" }}>
              {h(data.title_en, data.title_ar)}
            </h2>
            <p style={{ color: "rgba(255,255,255,0.8)", maxWidth: 520, margin: "0 auto 2.5rem", lineHeight: 1.7, fontSize: "0.95rem" }}>
              {h(data.subtitle_en, data.subtitle_ar)}
            </p>
            <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap", flexDirection: isRTL ? "row-reverse" : "row" }}>
              <a href={data.btn1_href} style={{ background: "white", color: "var(--color-purple)", border: "none", padding: "0.9rem 2.2rem", borderRadius: "50px", fontWeight: 700, fontSize: "0.95rem", cursor: "pointer", boxShadow: "0 8px 24px rgba(0,0,0,0.2)", letterSpacing: "0.02em", textDecoration: "none", display: "inline-block" }}>
                {h(data.btn1_en, data.btn1_ar)}
              </a>
              <a href={data.btn2_href} style={{ background: "transparent", color: "white", border: "2px solid rgba(255,255,255,0.4)", padding: "0.9rem 2.2rem", borderRadius: "50px", fontWeight: 600, fontSize: "0.95rem", cursor: "pointer", textDecoration: "none", display: "inline-block" }}>
                {h(data.btn2_en, data.btn2_ar)}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
